<template>
  <div class="statistics">
    <div class="row">
      <div class="key">{{ $t('message.numberOfProducts') }}：</div>
      <div class="val">{{ statistics.num }}</div>
    </div>
    <div class="row">
      <div class="key">{{ $t('message.sum') }}：</div>
      <div class="val">{{ statistics.amount.toFixed(2) }}</div>
    </div>
    <div class="row">
      <div class="key">{{ $t('message.boxNum') }}：</div>
      <div class="val">{{ checkedList.length }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    checkedList: { type: Array, default: () => [] }
  },
  computed: {
    statistics() {
      const total = { num: 0, amount: 0 }
      // 按选中箱子汇总，商品数量取箱内实际装箱数，金额取箱内货值。
      this.checkedList.forEach(box => {
        total.amount += Number(box.goods_value || 0)
        ;(box.order_detail_list || []).forEach(goods => {
          total.num += Number(goods.num || 0)
        })
      })
      return total
    }
  }
}
</script>
<style lang="scss" scoped>
.row {
  display: flex;
  margin-bottom: 5px;
  color: #000;

  .key {
    width: 100px;
    margin-right: 10px;
  }

  .val {
    color: #B4272D;
  }
}
</style>
